import React from 'react';
import { Typography } from '@mui/material';
import { StudySessionsOptions } from '../../types/study-sessions';

interface OptionSelectedFeedbackProps {
  boxClassName?: string;
  className?: string;
  selectedStudySession: string;
  studySessionsOptions: StudySessionsOptions;
}

const OptionSelectedFeedback: React.FC<OptionSelectedFeedbackProps> = ({
  boxClassName,
  className,
  selectedStudySession,
  studySessionsOptions,
}) => {
  const [studySessionOptionSelected, setStudySessionOptionSelected] = React.useState<
    StudySessionsOptions[0] | null
  >(null);

  React.useEffect(() => {
    const selectedStudySessionOption = studySessionsOptions.find(
      (option) => option.name === selectedStudySession,
    );
    setStudySessionOptionSelected(selectedStudySessionOption || null);
  }, [selectedStudySession, studySessionsOptions]);

  if (!studySessionOptionSelected) return null;
  return (
    <article
      className={`flex gap-6 items-center p-6 rounded-2xl w-full md:w-[450px] ${boxClassName}`}
    >
      <img
        loading="lazy"
        src={studySessionOptionSelected.feedback.imageSrc}
        alt={studySessionOptionSelected.altText}
        className={`${className}`}
      />
      <Typography variant="s1" component="p" className="text-left" color="contrastText">
        {studySessionOptionSelected.feedback.text}
      </Typography>
    </article>
  );
};

export default OptionSelectedFeedback;
